"use strict";
/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SizeLimitedCache = void 0;
var SizeLimitedCache = /** @class */ (function () {
    function SizeLimitedCache(maxSize) {
        this._keys = [];
        this._entries = new Map();
        this._maxSize = maxSize;
    }
    Object.defineProperty(SizeLimitedCache.prototype, "totalSize", {
        get: function () {
            if (this._entries.size === 0) {
                return 0;
            }
            return Array.from(this._entries.values())
                .map(function (entry) { return entry.size; })
                .reduce(function (a, b) { return a + b; }, 0);
        },
        enumerable: false,
        configurable: true
    });
    SizeLimitedCache.prototype._makeRoomForSize = function (size) {
        while (this.totalSize + size > this._maxSize) {
            // Case where shift returns undefined is unreachable because of the size > maxSize check in set.
            this._entries.delete(this._keys.shift());
        }
    };
    SizeLimitedCache.prototype.clear = function () {
        this._keys.length = 0;
        this._entries.clear();
    };
    SizeLimitedCache.prototype.has = function (key) {
        return this._entries.has(key);
    };
    SizeLimitedCache.prototype.set = function (key, item, size) {
        if (size > this._maxSize) {
            throw new Error("Item size is larger than the maximum cache size.");
        }
        this._makeRoomForSize(size);
        this._keys.push(key);
        this._entries.set(key, {
            item: item,
            size: size,
        });
    };
    SizeLimitedCache.prototype.get = function (key) {
        var _a;
        return (_a = this._entries.get(key)) === null || _a === void 0 ? void 0 : _a.item;
    };
    SizeLimitedCache.prototype.dispose = function () {
        this.clear();
    };
    return SizeLimitedCache;
}());
exports.SizeLimitedCache = SizeLimitedCache;
//# sourceMappingURL=SizeLimitedCache.js.map